import React, { useEffect } from 'react';
import { Navigate, Route, Routes, useParams } from 'react-router-dom';
import { PublicBackground } from '@app/core';
import {
  ParticipationStatus,
  useParticipation,
  useParticipationIncentiveText,
  usePublicSession,
  useRecruitment,
  useViewParticipationPage,
} from '@app/api';
import { StudyLanding } from '../StudyApplication/StudyLanding';
import { ApplicationSteps } from '../StudyApplication/ApplicationSteps';
import { setLocale } from '@app/i18n';
import { TrackApplicationContainer } from '../StudyApplication/components/TrackApplicationContainer';

export const ParticipantBooking = () => {
  const { id } = useParams();

  const { data: participation, isLoading: fetching } = useParticipation(id);
  const { data: session, isLoading: fetchingSession } = usePublicSession(
    participation?.sessionId,
  );
  const { data: recruitment, isLoading: recruitmentLoading } = useRecruitment(
    session?.recruitmentId,
  );
  const incentiveText = useParticipationIncentiveText(participation, session);
  useViewParticipationPage(id);

  const locale = session?.locale;
  useEffect(() => {
    if (!locale) {
      return;
    }
    setLocale(locale);
  }, [locale]);

  if (
    !fetching &&
    participation &&
    participation.status !== ParticipationStatus.INVITED &&
    participation.status !== ParticipationStatus.APPLIED
  ) {
    return <Navigate to={`/p/${participation.id}`} />;
  }

  if (!session || !participation || !recruitment || !session.status) {
    return (
      <PublicBackground
        isLoading={fetching || fetchingSession || recruitmentLoading}
      />
    );
  }

  return (
    <TrackApplicationContainer
      sessionId={session.id}
      sessionLinkId={participation.sessionLinkId}
    >
      <Routes>
        <Route
          index
          element={
            <StudyLanding
              session={session}
              recruitment={recruitment}
              participantId={participation.participantId}
              participation={participation}
              sessionLinkId={participation.sessionLinkId}
            />
          }
        />
        <Route
          path="*"
          element={
            <ApplicationSteps
              session={session}
              recruitment={recruitment}
              incentiveText={incentiveText}
              participantId={participation.participantId}
              sessionLinkId={participation.sessionLinkId}
              trackingId={participation.trackingId}
            />
          }
        />
      </Routes>
    </TrackApplicationContainer>
  );
};
